import React, { useState, useRef, useReducer } from 'react';


function ShoppingList() {

  const inputRef = useRef();
  const [items, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'add':
        return [
          ...state,
          {
            id: state.length,
            name: action.name
          }
        ];
      case 'remove':
        // keep every item except the one we want to remove
        return state.filter((_, index) => index != action.index);
      case "clear":
        return [];
      default:
        return state;
    }
  }, []);

  function handleSubmit(e) {
    e.preventDefault();
    dispatch({
      type: 'add',
      name: inputRef.current.value
    });
    inputRef.current.value = '';
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <input ref={inputRef} />
      </form>
      <button onClick={() => dispatch({ type: "clear" })}>Clear</button>
      <ul>
        {items.map((item, index) => (
          <li key={item.id}>
            {item.name}{" "}
            <button onClick={() => dispatch({ type: "remove", index })}>
              X
            </button>
          </li>
        ))}
      </ul>
    </>
  );
}


export default ShoppingList;
/*

<mx:Canvas width="100%" height="100%">
    	<flexiframe:IFrame id="iFrameWithJSfunctions"
                       label="Map"
                       source="http://bi.unidatanet.com.br/VLI/#/pages/itemGraficoEvolucaoPostos?url="
                       width="100%"
                       height="100%"
                       overlayDetection="true" />
    </mx:Canvas>

<mx:Canvas width="100%" height="100%">
    	<flexiframe:IFrame id="iFrameWithJSfunctions"
                       label="Map"
                       source="http://bi.unidatanet.com.br/VLI/#/pages/itemGraficoDescargaDifNF?url="
                       width="100%"
                       height="100%"
                       overlayDetection="true" />
    </mx:Canvas>

    <mx:Canvas width="100%" height="100%">
    	<flexiframe:IFrame id="iFrameWithJSfunctions"
                       label="Map"
                       source="http://bi.unidatanet.com.br/VLI/#/pages/itemGraficoTurnoResumo01?url="
                       width="100%"
                       height="100%"
                       overlayDetection="true" />
    </mx:Canvas>


	<mx:Canvas width="100%" height="100%">
    	<flexiframe:IFrame id="iFrameWithJSfunctions"
                       label="Map"
                       source="http://bi.unidatanet.com.br/VLI/#/pages/itemGraficoTurnoResumoPSDia?url="
                       width="100%"
                       height="100%"
                       overlayDetection="true" />
    </mx:Canvas>

    <mx:Canvas width="100%" height="100%">
    	<flexiframe:IFrame id="iFrameWithJSfunctions"
                       label="Map"
                       source="http://bi.unidatanet.com.br/VLI/#/pages/itemFrmTurnoResumoAderencia?url="
                       width="100%"
                       height="100%"
                       overlayDetection="true" />
    </mx:Canvas>



    */
